import React from 'react'
import { Typography, Box } from '@mui/material'
import DataTable from './DataTable'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'

import { allPictogramsAtom } from 'atoms'

const SyntaxDebugger = () => {
  const { t } = useTranslation()
  const allPictograms = useAtomValue(allPictogramsAtom)
  return (
    <Box my={4}>
      <Typography variant="h6">{t('processedData')}</Typography>
      <DataTable data={allPictograms} />
    </Box>
  )
}

export default SyntaxDebugger
